import moment from "moment";
import idM from "moment/locale/id";

export const rupiahFormat = (param) => {
  if (!param) {
    return "-";
  }

  if (isNaN(+param)) {
    return param;
  }

  const price = new Intl.NumberFormat("id-ID", {
    style: "currency",
    currency: "IDR",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(param);
  return price;
};

export const dateFormat = (param) => {
  if (!param) {
    return "-";
  }
  return moment(param).locale("id", idM).format("DD MMMM YYYY");
};